@if (data) {
  <app-dashboard-value-display-settings-input
    [data]="data"
  ></app-dashboard-value-display-settings-input>
}
